<script>
export let checked = false;
export let label = '';
export let checkbox = false;
</script>



<label class="d-if ai-c">
  <input
    class="mb-0"
    type="checkbox"
    bind:checked={checked}
    hidden={!checkbox}
  />
  <span>{label}</span>
</label>



<style>
  input:not(:checked) + span {
    filter: grayscale(1);
  }
</style>
